import styled from "@emotion/styled";

const ActionButton = styled.div`
  margin: 20px 110px;
  
  @media screen and (max-width: 898px) {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 20px 0;
  }
`

const ContentWrapper = styled.div`

  @media screen and (max-width: 898px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: 20px;
  }
`


export {
  ActionButton,
  ContentWrapper
}